import React, { createContext, useContext, useState, useEffect } from 'react';
import { authService } from '../services/api';
import i18n from '../i18n';

const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      authService.setToken(token);
      authService.getCurrentUser()
        .then(user => {
          setCurrentUser(user);
          if (user.preferred_language) {
            i18n.changeLanguage(user.preferred_language);
          }
        })
        .catch(() => {
          localStorage.removeItem('token');
          authService.setToken(null);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (username, password) => {
    const response = await authService.login(username, password);
    localStorage.setItem('token', response.access_token);
    authService.setToken(response.access_token);
    setCurrentUser(response.user);
    if (response.user.preferred_language) {
      i18n.changeLanguage(response.user.preferred_language);
    }
    return response;
  };

  const logout = () => {
    localStorage.removeItem('token');
    authService.setToken(null);
    setCurrentUser(null);
  };

  const value = {
    currentUser,
    login,
    logout
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};